module.exports = __webpack_public_path__ + "static/media/eng.2d841ff2.svg";